"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiLinkOverrides = void 0;
var createMuiLinkOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            "&$focusVisible": {
                outline: "1px solid " + palette.text.primary,
                outlineOffset: spacing(1),
                textDecoration: "none",
            },
            "&:hover": {
                textDecoration: "none",
            },
            "&:active": {
                opacity: 1 - palette.action.activatedOpacity,
                textDecoration: "underline",
            },
        },
        button: {
            "&:disabled": {
                opacity: palette.action.disabledOpacity,
                cursor: "default",
                textDecoration: "underline",
            },
        },
    });
};
exports.createMuiLinkOverrides = createMuiLinkOverrides;
//# sourceMappingURL=MuiLink.js.map